import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dropdown standalone-menu" }
const _hoisted_2 = ["disabled", "aria-expanded"]

import { DropdownMenuItem } from "@medapro-types/common/components/DropdownMenu";
import DropdownChildMenu from "./DropdownChildMenuItem.vue";
import { computed, reactive } from "vue";
import Icon from "../Icon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownMenu',
  props: {
    text: {},
    icon: {},
    buttonClass: {},
    items: {},
    right: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



const items = computed(() => props.items || []);

const resolvedIcon = reactive({
  isCoreUI: !props.icon?.startsWith("mdp"),
  kind: props.icon?.replace(/^(.){4}/, "").trim()
});

const buttonClasses = computed(() => props.buttonClass || "mono");

const viewModel = reactive({
  open: false
});

function selectedHandler() {
  viewModel.open = false;
}

__expose({ selectedHandler });

return (_ctx: any,_cache: any) => {
  const _directive_safe_class = _resolveDirective("safe-class")!
  const _directive_on_click_outside = _resolveDirective("on-click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("button", {
      class: "btn dropdown-toggle",
      type: "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      disabled: props.disabled,
      "aria-expanded": viewModel.open,
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (viewModel.open = !viewModel.open), ["prevent"]))
    }, [
      (_ctx.icon)
        ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            "core-ui": resolvedIcon.isCoreUI,
            icon: resolvedIcon.kind
          }, null, 8, ["core-ui", "icon"]))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(props.text || ""), 1)
    ], 8, _hoisted_2)), [
      [_directive_safe_class, buttonClasses.value]
    ]),
    _createElementVNode("ul", {
      class: _normalizeClass(["dropdown-menu", { show: viewModel.open, right: props.right }]),
      "aria-labelledby": "dropdownMenuButton"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (entry, index) => {
        return (_openBlock(), _createBlock(DropdownChildMenu, {
          item: entry,
          key: index,
          onSelected: selectedHandler
        }, null, 8, ["item"]))
      }), 128))
    ], 2)
  ])), [
    [_directive_on_click_outside, selectedHandler]
  ])
}
}

})